(function () {
  'use strict';

  var STORAGE_KEY = 'streamline_customer_info';

  var popup = null;
  var popupForm = null;
  var nameInput = null;
  var emailInput = null;
  var errorElement = null;
  var submitButton = null;

  var pendingProductForm = null;
  var bypassNextProductSubmission = false;
  var cartCheckRunning = false;
  var checkoutRedirectRunning = false;

  function getShopifyRoot() {
    if (
      window.Shopify &&
      window.Shopify.routes &&
      window.Shopify.routes.root
    ) {
      return window.Shopify.routes.root;
    }

    return '/';
  }

  function getSavedCustomerInfo() {
    try {
      var savedInfo = localStorage.getItem(STORAGE_KEY);

      if (!savedInfo) {
        return null;
      }

      return JSON.parse(savedInfo);
    } catch (error) {
      console.error('Unable to read customer information:', error);
      return null;
    }
  }

  function hasCustomerInfo() {
    var customerInfo = getSavedCustomerInfo();

    return Boolean(
      customerInfo &&
      customerInfo.name &&
      customerInfo.email
    );
  }

  function showError(message) {
    if (!errorElement) {
      return;
    }

    errorElement.textContent = message;
    errorElement.hidden = false;
  }

  function clearError() {
    if (!errorElement) {
      return;
    }

    errorElement.textContent = '';
    errorElement.hidden = true;
  }

  function openPopup(productForm) {
    if (!popup) {
      return;
    }

    pendingProductForm = productForm;

    popup.classList.add('is-open');
    popup.setAttribute('aria-hidden', 'false');
    document.body.classList.add('customer-info-popup-open');

    window.setTimeout(function () {
      if (nameInput) {
        nameInput.focus();
      }
    }, 50);
  }

  function closePopup() {
    if (!popup) {
      return;
    }

    popup.classList.remove('is-open');
    popup.setAttribute('aria-hidden', 'true');
    document.body.classList.remove('customer-info-popup-open');
  }

  async function isCartEmpty() {
    var response = await fetch(
      getShopifyRoot() + 'cart.js',
      {
        method: 'GET',
        credentials: 'same-origin',
        headers: {
          Accept: 'application/json'
        }
      }
    );

    if (!response.ok) {
      throw new Error('Unable to check the cart.');
    }

    var cart = await response.json();

    return Number(cart.item_count) === 0;
  }

  function findProductForm(target) {
    if (!target || typeof target.closest !== 'function') {
      return null;
    }

    var form = target.closest('form');

    if (!form) {
      return null;
    }

    var action = form.getAttribute('action') || '';

    if (
      action.indexOf('/cart/add') !== -1 ||
      form.querySelector('[name="id"]')
    ) {
      return form;
    }

    return null;
  }

  function submitProductForm(productForm) {
    if (!productForm) {
      return;
    }

    bypassNextProductSubmission = true;

    if (typeof productForm.requestSubmit === 'function') {
      productForm.requestSubmit();
    } else {
      productForm.submit();
    }
  }

  function continueOriginalAddToCart() {
    if (!pendingProductForm) {
      return;
    }

    var productForm = pendingProductForm;

    pendingProductForm = null;
    closePopup();

    submitProductForm(productForm);
  }

  async function redirectToPrefilledCheckout() {
    if (checkoutRedirectRunning) {
      return;
    }

    checkoutRedirectRunning = true;

    try {
      var customerInfo = getSavedCustomerInfo();

      if (!customerInfo || !customerInfo.email) {
        window.location.href = getShopifyRoot() + 'checkout';
        return;
      }

      var name = String(customerInfo.name || '').trim();
      var email = String(customerInfo.email || '').trim();

      var nameParts = name
        .split(/\s+/)
        .filter(Boolean);

      var firstName = nameParts.shift() || '';
      var lastName = nameParts.join(' ');

      var cartResponse = await fetch(
        getShopifyRoot() + 'cart.js',
        {
          method: 'GET',
          credentials: 'same-origin',
          headers: {
            Accept: 'application/json'
          }
        }
      );

      if (!cartResponse.ok) {
        throw new Error('Unable to load the cart.');
      }

      var cart = await cartResponse.json();

      if (!cart.items || !cart.items.length) {
        window.location.href = getShopifyRoot() + 'cart';
        return;
      }

      var cartItems = cart.items
        .map(function (item) {
          return item.variant_id + ':' + item.quantity;
        })
        .join(',');

      var parameters = new URLSearchParams();

      parameters.set(
        'checkout[email]',
        email
      );

      if (firstName) {
        parameters.set(
          'checkout[shipping_address][first_name]',
          firstName
        );
      }

      if (lastName) {
        parameters.set(
          'checkout[shipping_address][last_name]',
          lastName
        );
      }

      var checkoutUrl =
        getShopifyRoot() +
        'cart/' +
        cartItems +
        '?' +
        parameters.toString();

      window.location.assign(checkoutUrl);
    } catch (error) {
      console.error(
        'Prefilled checkout redirect failed:',
        error
      );

      window.location.href = getShopifyRoot() + 'checkout';
    }
  }

  document.addEventListener('DOMContentLoaded', function () {
    popup = document.getElementById(
      'streamline-customer-info-popup'
    );

    if (!popup) {
      console.warn('Customer information popup was not found.');
      return;
    }

    popupForm = popup.querySelector(
      '#StreamlineCustomerInfoForm'
    );

    nameInput = popup.querySelector(
      '#StreamlineCustomerName'
    );

    emailInput = popup.querySelector(
      '#StreamlineCustomerEmail'
    );

    errorElement = popup.querySelector(
      '[data-customer-popup-error]'
    );

    submitButton = popup.querySelector(
      '[data-customer-popup-submit]'
    );

    popup
      .querySelectorAll('[data-customer-popup-close]')
      .forEach(function (element) {
        element.addEventListener('click', function (event) {
          event.preventDefault();
          closePopup();
        });
      });

    if (popupForm) {
      popupForm.addEventListener('submit', function (event) {
        event.preventDefault();
        clearError();

        var name = nameInput
          ? nameInput.value.trim()
          : '';

        var email = emailInput
          ? emailInput.value.trim()
          : '';

        if (!name) {
          showError('Please enter your name.');
          return;
        }

        if (!email) {
          showError('Please enter your email.');
          return;
        }

        var validEmail =
          /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email);

        if (!validEmail) {
          showError('Please enter a valid email address.');
          return;
        }

        if (submitButton) {
          submitButton.disabled = true;
          submitButton.classList.add('is-loading');
        }

        try {
          localStorage.setItem(
            STORAGE_KEY,
            JSON.stringify({
              name: name,
              email: email
            })
          );

          continueOriginalAddToCart();
        } catch (error) {
          console.error(
            'Unable to save customer information:',
            error
          );

          showError(
            'Unable to save your information. Please try again.'
          );
        } finally {
          if (submitButton) {
            submitButton.disabled = false;
            submitButton.classList.remove('is-loading');
          }
        }
      });
    }
  });

  /*
   * Capture Streamline product-form submissions.
   */
  document.addEventListener(
    'submit',
    async function (event) {
      var productForm = findProductForm(event.target);

      if (!productForm) {
        return;
      }

      if (bypassNextProductSubmission) {
        bypassNextProductSubmission = false;
        return;
      }

      if (hasCustomerInfo()) {
        return;
      }

      if (cartCheckRunning) {
        event.preventDefault();
        event.stopImmediatePropagation();
        return;
      }

      event.preventDefault();
      event.stopImmediatePropagation();

      cartCheckRunning = true;

      try {
        var cartEmpty = await isCartEmpty();

        if (!cartEmpty) {
          submitProductForm(productForm);
          return;
        }

        openPopup(productForm);
      } catch (error) {
        console.error(
          'Customer popup cart check failed:',
          error
        );

        submitProductForm(productForm);
      } finally {
        cartCheckRunning = false;
      }
    },
    true
  );

  /*
   * Capture common Streamline Add to Cart buttons,
   * including the product-page button shown in your HTML:
   * button[name="add"][data-add-to-cart]
   */
  document.addEventListener(
    'click',
    async function (event) {
      var addButton = event.target.closest(
        'button[name="add"],' +
        '[data-add-to-cart],' +
        '.add-to-cart,' +
        '.btn--add-to-cart'
      );

      if (!addButton) {
        return;
      }

      var productForm = findProductForm(addButton);

      if (!productForm) {
        return;
      }

      if (
        bypassNextProductSubmission ||
        hasCustomerInfo()
      ) {
        return;
      }

      if (cartCheckRunning) {
        event.preventDefault();
        event.stopImmediatePropagation();
        return;
      }

      event.preventDefault();
      event.stopImmediatePropagation();

      cartCheckRunning = true;

      try {
        var cartEmpty = await isCartEmpty();

        if (!cartEmpty) {
          submitProductForm(productForm);
          return;
        }

        openPopup(productForm);
      } catch (error) {
        console.error(
          'Customer popup Add to Cart check failed:',
          error
        );

        submitProductForm(productForm);
      } finally {
        cartCheckRunning = false;
      }
    },
    true
  );

  /*
   * Intercept the real checkout actions.
   *
   * Included:
   * - Main Shopify checkout button
   * - Streamline cart drawer checkout
   * - Cart-page checkout
   * - Sezzle modal "Continue to checkout"
   *
   * Excluded:
   * - .sezzle-checkout-button
   *
   * The initial Sezzle button must remain untouched so it
   * can open the Sezzle information modal.
   */
  document.addEventListener(
    'click',
    function (event) {
      var checkoutButton = event.target.closest(
        'button[name="checkout"],' +
        '[name="checkout"],' +
        '[data-cart-submit],' +
        '.cart__checkout,' +
        '.cart__checkout--drawer,' +
        '.cart__checkout-button,' +
        '.drawer__checkout,' +
        'a[href="/checkout"],' +
        'a[href$="/checkout"],' +
        '.sezzle-checkout-button-modal-button'
      );

      if (!checkoutButton) {
        return;
      }

      if (
        checkoutButton.classList.contains(
          'sezzle-checkout-button'
        )
      ) {
        return;
      }

      if (!hasCustomerInfo()) {
        return;
      }

      event.preventDefault();
      event.stopImmediatePropagation();

      redirectToPrefilledCheckout();
    },
    true
  );
})();